var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50371 3.8897L9.4749 2.11428C9.68239 2.04017 9.90855 2.03667 10.1182 2.10431L15.6597 3.89188C15.9695 3.99181 16.2113 4.23629 16.3077 4.54718L17.908 9.7036C17.9679 9.89666 17.9679 10.1033 17.908 10.2964L16.2921 15.5033C16.2045 15.7856 15.9964 16.0148 15.7237 16.1291L10.2021 18.4446C9.94272 18.5534 9.64946 18.5479 9.39431 18.4294L4.43694 16.1278C4.19051 16.0134 4.00124 15.8036 3.91267 15.5468L2.11241 10.326C2.03957 10.1148 2.03957 9.88523 2.11241 9.67401L3.89467 4.50545C3.99366 4.21838 4.21773 3.99183 4.50371 3.8897Z",
    fill: "#4FBF34",
    stroke: "#4FBF34",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 8L9.00004 11.6667L7.33337 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimedIcon);
export default __webpack_public_path__ + "static/media/claimedIcon.a21926821330799519c9ebdbc1cc6926.svg";
export { ForwardRef as ReactComponent };